module.exports = __webpack_public_path__ + "img/recommendation-7.33d50584.svg";